const lang = document.documentElement.lang;
export { lang }
